module.exports = __webpack_public_path__ + "static/media/familysiteimg.f7f8e687.png";